export const GET_ALL_RETAILERS = 'GET_ALL_RETAILERS';
export const GET_TOTAL_REVENUE = 'GET_TOTAL_REVENUE';
export const GET_RETAILER_LOCATIONS = 'GET_RETAILER_LOCATIONS';
export const FETCHING_STARTS = 'FETCHING_STARTS';
export const FETCHING_STOPS = 'FETCHING_STOPS';
